import { Component } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-unauthorized',
  imports: [],
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss'
})
export class UnauthorizedComponent {

  constructor(public router: Router) { }
  
  navigateToHome() {
    this.router.navigate(['/'])
  }
}
